import { render, staticRenderFns } from "./cc.vue?vue&type=template&id=1cf0f343&scoped=true"
import script from "./cc.vue?vue&type=script&lang=js"
export * from "./cc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf0f343",
  null
  
)

export default component.exports